import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=0fafe7f0&scoped=true"
import script from "./Contest.vue?vue&type=script&lang=js"
export * from "./Contest.vue?vue&type=script&lang=js"
import style0 from "./Contest.vue?vue&type=style&index=0&id=0fafe7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafe7f0",
  null
  
)

export default component.exports